import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log('Supabase URL:', supabaseUrl ? 'Défini' : 'Non défini');
console.log('Supabase Key:', supabaseKey ? 'Défini' : 'Non défini');

if (!supabaseUrl || !supabaseKey) {
    throw new Error(`Configuration Supabase manquante:
        URL: ${supabaseUrl ? 'Présente' : 'Manquante'}
        Key: ${supabaseKey ? 'Présente' : 'Manquante'}
    `);
}

export const supabase = createClient(supabaseUrl, supabaseKey);